import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import {useEffect, useState} from "react";
import { Box, withStyles} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    toggleContainer: {
        backgroundColor: theme.palette.primary.background,
        height: "38px",
        margin: theme.spacing(2, 0),
        borderRadius: "4px",
        border: `1px solid ${theme.palette.primary.light}`,
        selected: theme.palette.primary.light,
        marginLeft:"50px"
    },
    root: {
        selected: {
            backgroundColor: "#109CF1",
        }
    }
}));

export default function AccountContactToggler({tabVal,requestBody,icpSelected,tenantId, ...props}){

    const CustomTab = withStyles({
        root: {
          textTransform: "none",
          minWidth: "100px",
          width: "100px",
        }
      })(Tab);

    const [type, setType] = React.useState("ACCOUNTS");
    const [position, setPosition] = React.useState("left")

    function handleChange(e,newPosition) {
        props.setTabVal(newPosition);
        handleFrequency(newPosition)
      }

      const handleFrequency = (newOptionSelected) => {

        if (newOptionSelected !== null && newOptionSelected !== undefined) {
            if (newOptionSelected === 0) {
                setPosition(0)
                setType("ACCOUNTS")
                 props.setSelectedType("ACCOUNTS")
                
            }
            else if (newOptionSelected === 1) {
                setPosition(1)
                setType("CONTACTS")
                props.setSelectedType("CONTACTS")
            }           
        } 
        else {
            setType("ACCOUNTS")
            setPosition(0)
        }
        
    };

    const classes = useStyles();

    return (
        <Box sx={{ maxWidth: "200px", borderBottomWidth:'0.2px', borderBottomColor: "rgb(211, 211, 211)"}}>
                <Tabs 
                style={{ borderBottom:'1px solid #D3D3D3', color:"#595959" }}
                indicatorColor="primary"
                TabIndicatorProps={{
                  style: {
                    backgroundColor: "#21DA8C",
                    height:"6px",
                    borderRadius: "3px"
                   }
                  }}
                  //position
                  value={(Number(tabVal) || 0)}
                onChange={handleChange}
                aria-label="wrapped label tabs example"
                variant="standard"
                >
                    
                    <CustomTab label="ACCOUNTS" ></CustomTab>
                    <CustomTab label="CONTACTS" ></CustomTab>

                </Tabs>
                </Box>
        // <ToggleButtonGroup
        //     className={classes.toggleContainer}
        //     value={position}
        //     exclusive
        //     onChange={handleAccountContactSelector}
        //     aria-label="text alignment"
        // >
        //     <ToggleButton value="left" aria-label="left aligned">
        //         Account
        //     </ToggleButton>
        //     <ToggleButton value="right" aria-label="right aligned">
        //         Contact
        //     </ToggleButton>
        // </ToggleButtonGroup>
    );
}